var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56247 0.433322C5.83681 -0.148263 6.6245 -0.140605 6.89646 0.433322L8.41794 3.655L11.8213 4.17258C12.4317 4.26516 12.6759 5.05156 12.2334 5.50168L9.77146 7.98606L10.3545 11.5261C10.4593 12.1663 9.8141 12.6433 9.27341 12.3464L6.22947 10.697L3.1865 12.3689C2.64491 12.6655 2.00085 12.1885 2.10544 11.5486L2.68845 8.00852L0.225559 5.50168C-0.216523 5.05146 0.0281723 4.26601 0.638645 4.17356L4.04197 3.655L5.56247 0.433322Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon1);
export default __webpack_public_path__ + "static/media/StarIcon1.ac35f75ec0ce1149244fd1135d2764e3.svg";
export { ForwardRef as ReactComponent };